import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Cookie } from 'lucide-react';

const STORAGE_KEY = 'cmic_cookie_consent';

const TEXT = {
  es: {
    message: 'Usamos cookies necesarias para el funcionamiento del sitio y para mejorar tu experiencia. Al continuar navegando aceptas nuestro uso de cookies.',
    accept: 'Aceptar',
    learn: 'Aviso de privacidad',
    privacyPath: 'aviso-de-privacidad',
  },
  en: {
    message: 'We use cookies that are necessary for the site to work and to improve your experience. By continuing to browse you accept our use of cookies.',
    accept: 'Accept',
    learn: 'Privacy notice',
    privacyPath: 'privacy',
  },
};

export default function CookieConsent({ locale = 'es' }) {
  const [visible, setVisible] = useState(false);
  const t = TEXT[locale] || TEXT.es;

  useEffect(() => {
    try {
      if (!localStorage.getItem(STORAGE_KEY)) setVisible(true);
    } catch { setVisible(true); }
  }, []);

  function accept() {
    try { localStorage.setItem(STORAGE_KEY, new Date().toISOString()); } catch { /* ignore */ }
    setVisible(false);
  }

  if (!visible) return null;

  return (
    <div
      data-testid="cookie-consent-banner"
      className="fixed bottom-0 inset-x-0 z-[70] p-3 sm:p-4 animate-in"
    >
      <div className="max-w-5xl mx-auto bg-charcoal-800 text-white rounded-2xl shadow-2xl border border-charcoal-700 p-4 sm:p-5 flex flex-col sm:flex-row sm:items-center gap-4">
        <div className="flex items-start gap-3 flex-1 min-w-0">
          <div className="w-9 h-9 rounded-xl bg-cmic-500/20 flex items-center justify-center flex-shrink-0">
            <Cookie size={18} className="text-cmic-300" />
          </div>
          <p className="text-sm text-charcoal-100 leading-relaxed">
            {t.message}{' '}
            <Link
              to={`/${locale}/${t.privacyPath}`}
              data-testid="cookie-consent-privacy-link"
              className="text-cmic-300 hover:text-white underline underline-offset-2 font-medium"
            >
              {t.learn}
            </Link>
          </p>
        </div>
        <button
          onClick={accept}
          data-testid="cookie-consent-accept"
          className="flex-shrink-0 inline-flex items-center justify-center bg-cmic-500 hover:bg-cmic-600 text-white px-6 py-2.5 rounded-lg text-sm font-semibold transition-colors shadow-sm whitespace-nowrap"
        >
          {t.accept}
        </button>
      </div>
    </div>
  );
}
